<template>
  <v-card>
    <v-dialog v-model="dialogs.merge" scrollable max-width="1200px" persistent>
      <material-card
        v-show="headers"
        :title="$t('components.searchmembersform.title')"
        :color="$vuetify.theme.themes.light.secondary"
        icon="person_search"
      >
        <v-card-text>
          <search-members-form-hours
            v-if="dialogs.merge"
            :usedInMerge="true"
            :firstName="item.FirstName"
            :lastName="item.LastName"
            :certificate="item.MemberCertificate"
            :employeeNumber="item.EmployeeNumber"
            :gender="item.Gender"
            :dateOfBirth="item.DateOfBirth"
            @merge="merge"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="dialogs.merge = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <!-- <v-btn
          :disabled="!valid"
          color="primary"
          :loading="saving"
          @click="save"
        >
          {{ $t("globals.save") }}
        </v-btn> -->
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog scrollable v-model="dialogs.create" persistent max-width="1400">
      <material-card
        :title="$t('components.membersimportwizardcomponent.create_new_member')"
        :color="$vuetify.theme.themes.light.success"
        icon="add"
      >
        <v-card-text>
          <create-member-wizard
            :recreate="recreate"
            v-if="dialogs.create"
            ref="addMemberWizard"
            @valid-changed="wizardValid"
            @new-member-saved="dialogs.create = false"
            :pendingImportId="pendingImportId"
            @save-in-dialog="saveOne"
            :employers="employers"
            :externalMember="member"
            :rowId="rowId"
            :termDate="item.StartDate"
          ></create-member-wizard>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="
              $refs.addMemberWizard.tryReleaseCertificate();
              dialogs.create = false;
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :loading="$refs.addMemberWizard && $refs.addMemberWizard.saving"
            :disabled="!addMemberWizardValid"
            color="primary"
            @click="$refs.addMemberWizard.save()"
          >
            {{ $t("globals.finish") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog v-model="addMany" scrollable max-width="1800px" persistent>
      <hours-add-many
        v-if="addMany"
        @close="addMany = false"
        @save="saveMany"
        :optionalColumns="optionalColumns"
        :requiredColumns="requiredColumns"
        :pendingImportId="pendingImportId"
        :employers="employers"
      />
    </v-dialog>
    <v-dialog v-model="dialogs.delete" max-width="600px" persistent>
      <v-card>
        <v-card-title class="headline">
          {{ $t("components.hoursbulktable.delete_title") }}
        </v-card-title>
        <v-card-text>
          {{ $t("components.hoursbulktable.delete_warning_text") }}
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="dialogs.delete = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="error" @click="deleteItem" :loading="saving">
            {{ $t("globals.delete") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogs.massCreate"
      scrollable
      max-width="600px"
      persistent
    >
      <material-card
        :title="$t('components.hoursbulktable.mass_create_members')"
        :color="$vuetify.theme.themes.light.success"
        icon="add"
      >
        <v-card-text v-if="planIdentity.HasEligibilityBank">
          <v-form v-model="validMass">
            <v-row>
              <div
                class="col-12 col-md-4 col-lg-3"
                v-if="
                  Object.keys(memberHeaders).indexOf(
                    'Default Coverage Status'
                  ) > -1
                "
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-container pa-0>
                      <v-row no-gutters>
                        <v-col>
                          <trans-select
                            :clearable="
                              memberHeaders['Default Coverage Status']
                                .isOptional === true
                            "
                            :item="massMembershipStatus"
                            propertyName="DefaultCoverageStatus"
                            :items="options.Models.FamilyStatus"
                            :label="
                              $t(
                                'headers.members_management.Default Coverage Status'
                              )
                            "
                            :class="
                              memberHeaders['Default Coverage Status']
                                .isOptional === false
                                ? 'required'
                                : []
                            "
                            :rules="
                              memberHeaders['Default Coverage Status']
                                .isOptional === false
                                ? [$rules.required]
                                : []
                            "
                          ></trans-select>
                        </v-col>
                        <v-col
                          style="margin-top: 20px; margin-left: 3px"
                          cols="auto"
                        >
                          <v-icon v-bind="attrs" v-on="on">help</v-icon>
                        </v-col>
                      </v-row>
                    </v-container>
                  </template>
                  <span>
                    {{
                      $t(
                        "components.addmemberwizard.default_coverage_status_tooltip"
                      )
                    }}
                  </span>
                </v-tooltip>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3"
                v-if="Object.keys(memberHeaders).indexOf('Class') > -1"
              >
                <auto-select
                  clear-icon="clear"
                  :clearable="memberHeaders['Class'].isOptional === true"
                  :label="$t('headers.members_management.Class')"
                  :value.sync="massMembershipStatus.Class"
                  :items="classes"
                  :class="
                    memberHeaders['Class'].isOptional === false
                      ? 'required'
                      : []
                  "
                  :rules="
                    memberHeaders['Class'].isOptional === false > -1
                      ? [$rules.required]
                      : []
                  "
                ></auto-select>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3"
                v-if="Object.keys(memberHeaders).indexOf('Member Group') > -1"
              >
                <trans-select2
                  v-model="massMembershipStatus.MemberGroupIdentity"
                  propertyName="Current"
                  :items="memberGroups"
                  :label="$t('headers.members_management.Member Group')"
                  :rules="[$rules.required]"
                  field="Name"
                  itemValue="IdentityId"
                  class="required"
                ></trans-select2>
              </div>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-text v-else>
          {{ $t("components.hoursbulktable.mass_create_warning_text") }}
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="dialogs.massCreate = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="primary" @click="massCreate" :loading="saving">
            {{ $t("components.hoursbulktable.create") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <template v-if="provider !== null && provider !== undefined">
      <v-card-actions>
        <div class="btns-container">
          <v-btn
            text
            color="black darken-1"
            @click="clearFilters"
            :disabled="
              provider.filter === null || provider.filter === undefined
            "
          >
            {{ $t("pbascomponents.pbasdatatable.clear_filters") }}
          </v-btn>
          <v-btn
            text
            color="black darken-1"
            @click="filterNewMembers"
            :disabled="provider.filter === 'IsNew eq true'"
          >
            {{ $t("components.hoursbulktable.new_members") }}
          </v-btn>
          <v-btn
            text
            color="black darken-1"
            @click="filterErrors"
            :disabled="
              provider.filter === 'IsValid eq false and IsNew eq false'
            "
          >
            {{ $t("components.hoursbulktable.errors") }}
          </v-btn>
          <v-btn
            text
            color="black darken-1"
            @click="filterValid"
            :disabled="provider.filter === 'IsValid eq true or IsNew eq true'"
          >
            {{ $t("components.hoursbulktable.valid_records") }}
          </v-btn>
        </div>
        <v-spacer />
        <v-btn
          style="margin-right: 13px"
          color="warning"
          @click="calculateContribution"
          :disabled="true"
        >
          {{ $t("components.hoursbulktable.calculate_contribution") }}
        </v-btn>
      </v-card-actions>
      <v-divider />
      <v-card-text>
        <pbas-data-table
          @itemsChanged="setData($event)"
          ref="table"
          :dataProvider="provider"
          identifier="hoursBulkTableIdentifier"
          @error="error = $event"
          @items-change-warning="itemsChangeWarning($event)"
          :itemsChangeWarning="true"
          :floatActions="floatActions"
          :rowActions="rowActions"
          :selectActions="selectActions"
          :showSelect="false"
        >
          <template
            v-for="(header, index) in provider.headers"
            v-slot:[headerSlotFunc(header)]="{ header }"
          >
            <div :key="header.value" style="display: inline-block">
              <v-checkbox
                v-if="header.type.key === 'Id'"
                :value="allSelected"
                @change="toggleAll"
                :indeterminate="someChecked"
                style="display: inline-block"
              />
              <span v-else>{{ $t(header.title) }}</span>
            </div>
          </template>
          <template
            v-for="(header, index) in provider.headers"
            v-slot:[itemSlotFunc(header)]="{ item }"
          >
            <div
              v-bind:key="header.type.key"
              :style="
                'justify-content: ' +
                (header.align != 'center' ? 'flex-' + header.align : 'center')
              "
              @contextmenu.prevent="
                contextMenuSelectedItem = item;
                contextMenuOpened = true;
                if ($refs.menu != null) $refs.menu.open($event);
              "
              :class="item.isSelected ? 'selected-row' : ''"
            >
              <template v-if="header.type.key === 'Id'">
                <v-checkbox
                  :value="item.isSelected"
                  @change="toggle(item)"
                  v-if="item.IsNew && item.Errors.length === 1"
                />
                <div v-else style="margin-right: 30px"></div>
              </template>
              <v-menu
                offset-y
                v-if="
                  header.type.key === 'PendingImportId' &&
                  getActionsFor(item).length > 0
                "
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    text
                    v-bind="attrs"
                    v-on="on"
                    style="margin-right: 10px"
                  >
                    <v-icon>list</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="action in getActionsFor(item)"
                    :key="action.name"
                    @click.prevent="action.handler(item)"
                  >
                    <v-list-item-icon style="margin-right: 10px">
                      <v-icon>{{ action.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                      {{ $t(action.title) }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-tooltip
                top
                v-bind:key="header.type.key"
                v-if="header.type.key === 'IsValid' && item.onlyNewMemberError"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-icon
                      v-if="
                        $refs.table.fetchResult.items.indexOf(item) % 2 === 0
                      "
                      v-bind="attrs"
                      v-on="on"
                      v-bind:key="header.type.key"
                      style="
                        color: #008080 !important;
                        background-color: rgba(0, 0, 0, 0.02);
                      "
                    >
                      add_circle_outline
                    </v-icon>
                    <v-icon
                      v-else
                      v-bind="attrs"
                      v-on="on"
                      v-bind:key="header.type.key"
                      style="
                        color: #008080 !important;
                        background-color: rgba(0, 0, 0, 0);
                      "
                    >
                      add_circle_outline
                    </v-icon>
                  </div>
                  <!-- <span v-bind:key="header.type.key" v-else>{{$t('components.hoursbulktable.not_validated_yet')}}</span> -->
                </template>
                <div class="previous-value-tooltip">
                  <template v-for="(error, index) in rowErrors(item)">
                    <div v-bind:key="index">
                      {{ error }}
                    </div>
                  </template>
                </div>
              </v-tooltip>
              <v-tooltip
                top
                v-bind:key="header.type.key"
                v-else-if="
                  header.type.key === 'IsValid' &&
                  rowErrors(item) &&
                  rowErrors(item).length > 0
                "
              >
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-icon
                      v-if="
                        $refs.table.fetchResult.items.indexOf(item) % 2 === 0
                      "
                      v-bind="attrs"
                      v-on="on"
                      v-bind:key="header.type.key"
                      style="
                        color: #fb8c00 !important;
                        background-color: rgba(0, 0, 0, 0.02);
                      "
                    >
                      error_outline
                    </v-icon>
                    <v-icon
                      v-else
                      v-bind="attrs"
                      v-on="on"
                      v-bind:key="header.type.key"
                      style="
                        color: #fb8c00 !important;
                        background-color: rgba(0, 0, 0, 0);
                      "
                    >
                      error_outline
                    </v-icon>
                  </div>
                  <!-- <span v-bind:key="header.type.key" v-else>{{$t('components.hoursbulktable.not_validated_yet')}}</span> -->
                </template>
                <div class="previous-value-tooltip">
                  <template v-for="(error, index) in rowErrors(item)">
                    <div v-bind:key="index">
                      {{ error }}
                    </div>
                  </template>
                </div>
              </v-tooltip>
              <div v-else-if="header.type.key === 'IsValid' && item.IsValid">
                <template v-if="item.IsNew &&
                    item.NewMember !== null &&
                    item.NewMember !== undefined">
                <v-icon
                  v-if="$refs.table.fetchResult.items.indexOf(item) % 2 === 0"
                  v-bind:key="header.type.key"
                  style="color: #4caf50; background-color: rgba(0, 0, 0, 0.02)"
                >
                add_task
                </v-icon>
                <v-icon
                  v-else
                  v-bind:key="header.type.key"
                  style="color: #4caf50; background-color: rgba(0, 0, 0, 0)"
                >
                add_task
                </v-icon>
              </template>
              <template v-else>
                <v-icon
                  v-if="$refs.table.fetchResult.items.indexOf(item) % 2 === 0"
                  v-bind:key="header.type.key"
                  style="color: #4caf50; background-color: rgba(0, 0, 0, 0.02)"
                >
                  check_circle_outline
                </v-icon>
                <v-icon
                  v-else
                  v-bind:key="header.type.key"
                  style="color: #4caf50; background-color: rgba(0, 0, 0, 0)"
                >
                  check_circle_outline
                </v-icon>
              </template>
              </div>
              <v-tooltip
                top
                v-bind:key="header.type.key"
                v-else-if="header.type.key === 'IsValid' && !item.IsValid"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      v-bind:key="header.type.key"
                    >
                      help_outline
                    </v-icon>
                  </div>
                  <!-- <span v-bind:key="header.type.key" v-else>{{$t('components.hoursbulktable.not_validated_yet')}}</span> -->
                </template>
                <div class="previous-value-tooltip">
                  <div>
                    {{ $t("components.hoursbulktable.not_validated_yet") }}
                  </div>
                </div>
              </v-tooltip>
              <template v-if="header.type.key === 'MemberCertificate'">
                <no-autocomplete-textfield
                  @keydown.tab.prevent="nextCell(item.Id + '_0')"
                  dense
                  :ref="item.Id + '_0'"
                  v-if="isCellFocused(item.Id, 0)"
                  :disabled="
                    item.IsNew &&
                    item.NewMember !== null &&
                    item.NewMember !== undefined
                  "
                  clearable
                  v-bind:key="header.type.key"
                  style="min-width: 200px; padding: 0"
                  :value="item.MemberCertificate"
                  @input="updateRow($event, item, 'MemberCertificate')"
                  :rules="
                    requiredColumns.indexOf('MemberCertificate') > -1
                      ? [$rules.required]
                      : []
                  "
                  :class="
                    requiredColumns.indexOf('MemberCertificate') > -1
                      ? 'required'
                      : ''
                  "
                  label=" "
                  autofocus
                />
                <span
                  :ref="item.Id + '_0'"
                  class="pbas-table-cell"
                  v-on:dblclick="focusCell(item.Id, 0)"
                  v-else
                >
                  {{ item.MemberCertificate }}
                </span>
              </template>
              <template v-if="header.type.key === 'SIN'">
                <no-autocomplete-textfield
                  @keydown.tab.prevent="nextCell(item.Id + '_1')"
                  dense
                  :ref="item.Id + '_1'"
                  v-if="isCellFocused(item.Id, 1)"
                  :disabled="
                    item.IsNew &&
                    item.NewMember !== null &&
                    item.NewMember !== undefined
                  "
                  clearable
                  v-bind:key="header.type.key"
                  style="min-width: 200px; padding: 0"
                  :value="item.SIN"
                  @input="updateRow($event, item, 'SIN')"
                  :rules="
                    requiredColumns.indexOf('SIN') > -1 ? [$rules.required] : []
                  "
                  :class="requiredColumns.indexOf('SIN') > -1 ? 'required' : ''"
                  label=" "
                  autofocus
                />
                <span
                  :ref="item.Id + '_1'"
                  class="pbas-table-cell"
                  v-on:dblclick="focusCell(item.Id, 1)"
                  v-else
                >
                  {{ item.SIN }}
                </span>
              </template>
              <template v-if="header.type.key === 'FirstName'">
                <no-autocomplete-textfield
                  @keydown.tab.prevent="nextCell(item.Id + '_2')"
                  dense
                  :ref="item.Id + '_2'"
                  v-if="isCellFocused(item.Id, 2)"
                  :disabled="
                    item.IsNew &&
                    item.NewMember !== null &&
                    item.NewMember !== undefined
                  "
                  clearable
                  v-bind:key="header.type.key"
                  style="min-width: 200px; padding: 0"
                  :value="item.FirstName"
                  @input="updateRow($event, item, 'FirstName')"
                  :rules="
                    requiredColumns.indexOf('FirstName') > -1
                      ? [$rules.required]
                      : []
                  "
                  :class="
                    requiredColumns.indexOf('FirstName') > -1 ? 'required' : ''
                  "
                  label=" "
                  autofocus
                />
                <span
                  :ref="item.Id + '_2'"
                  class="pbas-table-cell"
                  v-on:dblclick="focusCell(item.Id, 2)"
                  v-else
                >
                  {{ item.FirstName }}
                </span>
              </template>
              <template v-if="header.type.key === 'LastName'">
                <no-autocomplete-textfield
                  @keydown.tab.prevent="nextCell(item.Id + '_3')"
                  dense
                  :ref="item.Id + '_3'"
                  v-if="isCellFocused(item.Id, 3)"
                  :disabled="
                    item.IsNew &&
                    item.NewMember !== null &&
                    item.NewMember !== undefined
                  "
                  clearable
                  v-bind:key="header.type.key"
                  style="min-width: 200px; padding: 0"
                  :value="item.LastName"
                  @input="updateRow($event, item, 'LastName')"
                  :rules="
                    requiredColumns.indexOf('LastName') > -1
                      ? [$rules.required]
                      : []
                  "
                  :class="
                    requiredColumns.indexOf('LastName') > -1 ? 'required' : ''
                  "
                  label=" "
                  autofocus
                />
                <span
                  :ref="item.Id + '_3'"
                  class="pbas-table-cell"
                  v-on:dblclick="focusCell(item.Id, 3)"
                  v-else
                >
                  {{ item.LastName }}
                </span>
              </template>
              <template v-if="header.type.key === 'Gender'">
                <no-autocomplete-textfield
                  @keydown.tab.prevent="nextCell(item.Id + '_4')"
                  dense
                  :ref="item.Id + '_4'"
                  v-if="isCellFocused(item.Id, 4)"
                  :disabled="
                    item.IsNew &&
                    item.NewMember !== null &&
                    item.NewMember !== undefined
                  "
                  clearable
                  v-bind:key="header.type.key"
                  style="min-width: 200px; padding: 0"
                  :value="item.Gender"
                  @input="updateRow($event, item, 'Gender')"
                  :rules="
                    requiredColumns.indexOf('Gender') > -1
                      ? [$rules.required]
                      : []
                  "
                  :class="
                    requiredColumns.indexOf('Gender') > -1 ? 'required' : ''
                  "
                  label=" "
                  autofocus
                />
                <span
                  :ref="item.Id + '_4'"
                  class="pbas-table-cell"
                  v-on:dblclick="focusCell(item.Id, 4)"
                  v-else
                >
                  {{ item.Gender }}
                </span>
              </template>
              <template v-if="header.type.key === 'DateOfBirth'">
                <pbas-date-picker
                  @keydown.tab.prevent="nextCell(item.Id + '_5')"
                  dense
                  :ref="item.Id + '_5'"
                  v-if="isCellFocused(item.Id, 5)"
                  :disabled="
                    item.IsNew &&
                    item.NewMember !== null &&
                    item.NewMember !== undefined
                  "
                  clearable
                  v-bind:key="header.type.key"
                  style="min-width: 200px; margin: 0 auto 15px"
                  :value="item.DateOfBirth"
                  @update-date="updateRow($event, item, 'DateOfBirth')"
                  :rules="
                    requiredColumns.indexOf('DateOfBirth') > -1
                      ? [$rules.required]
                      : []
                  "
                  :class="
                    requiredColumns.indexOf('DateOfBirth') > -1
                      ? 'required'
                      : ''
                  "
                  label=" "
                  autofocus
                />
                <span
                  :ref="item.Id + '_5'"
                  class="pbas-table-cell"
                  v-on:dblclick="focusCell(item.Id, 5)"
                  v-else
                >
                  {{ formatDate(item.DateOfBirth) }}
                </span>
              </template>
              <template v-if="header.type.key === 'Employer'">
                <no-autocomplete-textfield
                  @keydown.tab.prevent="nextCell(item.Id + '_6')"
                  dense
                  :ref="item.Id + '_6'"
                  v-if="isCellFocused(item.Id, 6)"
                  :disabled="
                    item.IsNew &&
                    item.NewMember !== null &&
                    item.NewMember !== undefined
                  "
                  clearable
                  v-bind:key="header.type.key"
                  style="min-width: 200px; padding: 0"
                  :value="item.Employer"
                  @input="updateRow($event, item, 'Employer')"
                  :rules="
                    requiredColumns.indexOf('Employer') > -1
                      ? [$rules.required]
                      : []
                  "
                  :class="
                    requiredColumns.indexOf('Employer') > -1 ? 'required' : ''
                  "
                  label=" "
                  autofocus
                />
                <span
                  :ref="item.Id + '_6'"
                  class="pbas-table-cell"
                  v-on:dblclick="focusCell(item.Id, 6)"
                  v-else
                >
                  {{ item.Employer }}
                </span>
              </template>
              <template v-if="header.type.key === 'EmployeeNumber'">
                <no-autocomplete-textfield
                  @keydown.tab.prevent="nextCell(item.Id + '_7')"
                  dense
                  :ref="item.Id + '_7'"
                  v-if="isCellFocused(item.Id, 7)"
                  :disabled="
                    item.IsNew &&
                    item.NewMember !== null &&
                    item.NewMember !== undefined
                  "
                  clearable
                  v-bind:key="header.type.key"
                  style="min-width: 200px; padding: 0"
                  :value="item.EmployeeNumber"
                  @input="updateRow($event, item, 'EmployeeNumber')"
                  :rules="
                    requiredColumns.indexOf('EmployeeNumber') > -1
                      ? [$rules.required]
                      : []
                  "
                  :class="
                    requiredColumns.indexOf('EmployeeNumber') > -1
                      ? 'required'
                      : ''
                  "
                  label=" "
                  autofocus
                />
                <span
                  :ref="item.Id + '_7'"
                  class="pbas-table-cell"
                  v-on:dblclick="focusCell(item.Id, 7)"
                  v-else
                >
                  {{ item.EmployeeNumber }}
                </span>
              </template>
              <template v-if="header.type.key === 'Store'">
                <no-autocomplete-textfield
                  @keydown.tab.prevent="nextCell(item.Id + '_8')"
                  dense
                  :ref="item.Id + '_8'"
                  v-if="isCellFocused(item.Id, 8)"
                  :disabled="
                    item.IsNew &&
                    item.NewMember !== null &&
                    item.NewMember !== undefined
                  "
                  clearable
                  v-bind:key="header.type.key"
                  style="min-width: 200px; padding: 0"
                  :value="item.Store"
                  @input="updateRow($event, item, 'Store')"
                  :rules="
                    (item.Employer &&
                      item.Employer.Stores &&
                      item.Employer.Stores.length > 0) ||
                    requiredColumns.indexOf('Store') > -1
                      ? [$rules.required]
                      : []
                  "
                  :class="
                    (item.Employer &&
                      item.Employer.Stores &&
                      item.Employer.Stores.length > 0) ||
                    requiredColumns.indexOf('Store') > -1
                      ? 'required'
                      : ''
                  "
                  label=" "
                  autofocus
                />
                <span
                  :ref="item.Id + '_8'"
                  class="pbas-table-cell"
                  v-on:dblclick="focusCell(item.Id, 8)"
                  v-else
                >
                  {{ item.Store }}
                </span>
              </template>
              <template v-if="header.type.key === 'Frequency'">
                <no-autocomplete-textfield
                  @keydown.tab.prevent="nextCell(item.Id + '_9')"
                  dense
                  :ref="item.Id + '_9'"
                  v-if="isCellFocused(item.Id, 9)"
                  :disabled="
                    item.IsNew &&
                    item.NewMember !== null &&
                    item.NewMember !== undefined
                  "
                  clearable
                  v-bind:key="header.type.key"
                  style="min-width: 200px; padding: 0"
                  :value="item.Frequency"
                  @input="updateRow($event, item, 'Frequency')"
                  :rules="
                    requiredColumns.indexOf('Frequency') > -1
                      ? [$rules.required]
                      : []
                  "
                  :class="
                    requiredColumns.indexOf('Frequency') > -1 ? 'required' : ''
                  "
                  label=" "
                  autofocus
                />
                <span
                  :ref="item.Id + '_9'"
                  class="pbas-table-cell"
                  v-on:dblclick="focusCell(item.Id, 9)"
                  v-else
                >
                  {{ item.Frequency }}
                </span>
              </template>
              <template v-if="header.type.key === 'EmploymentType'">
                <no-autocomplete-textfield
                  @keydown.tab.prevent="nextCell(item.Id + '_10')"
                  dense
                  :ref="item.Id + '_10'"
                  v-if="isCellFocused(item.Id, 10)"
                  :disabled="
                    item.IsNew &&
                    item.NewMember !== null &&
                    item.NewMember !== undefined
                  "
                  clearable
                  v-bind:key="header.type.key"
                  style="min-width: 200px; padding: 0"
                  :value="item.EmploymentType"
                  @input="updateRow($event, item, 'EmploymentType')"
                  :rules="
                    requiredColumns.indexOf('EmploymentType') > -1
                      ? [$rules.required]
                      : []
                  "
                  :class="
                    requiredColumns.indexOf('EmploymentType') > -1
                      ? 'required'
                      : ''
                  "
                  label=" "
                  autofocus
                />
                <span
                  :ref="item.Id + '_10'"
                  class="pbas-table-cell"
                  v-on:dblclick="focusCell(item.Id, 10)"
                  v-else
                >
                  {{ item.EmploymentType }}
                </span>
              </template>
              <template v-if="header.type.key === 'HireDate'">
                <pbas-date-picker
                  @keydown.tab.prevent="nextCell(item.Id + '_11')"
                  dense
                  :ref="item.Id + '_11'"
                  v-if="isCellFocused(item.Id, 11)"
                  :disabled="
                    item.IsNew &&
                    item.NewMember !== null &&
                    item.NewMember !== undefined
                  "
                  clearable
                  v-bind:key="header.type.key"
                  style="min-width: 200px; margin: 0 auto 15px"
                  :value="item.HireDate"
                  @update-date="updateRow($event, item, 'HireDate')"
                  :rules="
                    requiredColumns.indexOf('HireDate') > -1
                      ? [$rules.required]
                      : []
                  "
                  :class="
                    requiredColumns.indexOf('HireDate') > -1 ? 'required' : ''
                  "
                  label=" "
                  autofocus
                />
                <span
                  :ref="item.Id + '_11'"
                  class="pbas-table-cell"
                  v-on:dblclick="focusCell(item.Id, 11)"
                  v-else
                >
                  {{ formatDate(item.HireDate) }}
                </span>
              </template>
              <template v-if="header.type.key === 'Earnings'">
                <no-autocomplete-textfield
                  @keydown.tab.prevent="nextCell(item.Id + '_12')"
                  dense
                  :ref="item.Id + '_12'"
                  v-if="isCellFocused(item.Id, 12)"
                  :disabled="
                    item.IsNew &&
                    item.NewMember !== null &&
                    item.NewMember !== undefined
                  "
                  clearable
                  :fixedId="'earnings-textbox' + item.Id"
                  v-bind:key="header.type.key"
                  style="min-width: 200px; padding: 0"
                  :value="item.Earnings"
                  @input="updateRow($event, item, 'Earnings')"
                  @keydown="currencyKeydown"
                  @keyup="currencyKeyUp($event, item, 'Earnings')"
                  :rules="
                    requiredColumns.indexOf('Earnings') > -1
                      ? [$rules.required]
                      : []
                  "
                  :class="
                    requiredColumns.indexOf('Earnings') > -1 ? 'required' : ''
                  "
                  label=" "
                  autofocus
                />
                <span
                  :ref="item.Id + '_12'"
                  class="pbas-table-cell"
                  v-on:dblclick="focusCell(item.Id, 12)"
                  v-else
                >
                  {{ item.Earnings }}
                </span>
              </template>
              <template v-if="header.type.key === 'TermName'">
                <no-autocomplete-textfield
                  @keydown.tab.prevent="nextCell(item.Id + '_13')"
                  dense
                  :ref="item.Id + '_13'"
                  v-if="isCellFocused(item.Id, 13)"
                  clearable
                  v-bind:key="header.type.key"
                  style="min-width: 200px; padding: 0"
                  :value="item.TermName"
                  @input="updateRow($event, item, 'TermName')"
                  :rules="
                    requiredColumns.indexOf('TermName') > -1
                      ? [$rules.required]
                      : []
                  "
                  :class="
                    requiredColumns.indexOf('TermName') > -1 ? 'required' : ''
                  "
                  label=" "
                  autofocus
                />
                <span
                  :ref="item.Id + '_13'"
                  class="pbas-table-cell"
                  v-on:dblclick="focusCell(item.Id, 13)"
                  v-else
                >
                  {{ item.TermName }}
                </span>
              </template>
              <template v-if="header.type.key === 'TermYear'">
                <no-autocomplete-textfield
                  @keydown.tab.prevent="nextCell(item.Id + '_14')"
                  dense
                  :ref="item.Id + '_14'"
                  v-if="isCellFocused(item.Id, 14)"
                  clearable
                  v-bind:key="header.type.key"
                  style="min-width: 200px; padding: 0"
                  :value="item.TermYear"
                  @input="updateRow($event, item, 'TermYear')"
                  :rules="
                    requiredColumns.indexOf('TermYear') > -1
                      ? [$rules.required]
                      : []
                  "
                  :class="
                    requiredColumns.indexOf('TermYear') > -1 ? 'required' : ''
                  "
                  label=" "
                  autofocus
                />
                <span
                  :ref="item.Id + '_14'"
                  class="pbas-table-cell"
                  v-on:dblclick="focusCell(item.Id, 14)"
                  v-else
                >
                  {{ item.TermYear }}
                </span>
              </template>
              <template v-if="header.type.key === 'TerminationDate'">
                <pbas-date-picker
                  @keydown.tab.prevent="nextCell(item.Id + '_15')"
                  dense
                  :ref="item.Id + '_15'"
                  v-if="isCellFocused(item.Id, 15)"
                  :disabled="
                    item.IsNew &&
                    item.NewMember !== null &&
                    item.NewMember !== undefined
                  "
                  clearable
                  v-bind:key="header.type.key"
                  style="min-width: 200px; margin: 0 auto 15px"
                  :value="item.TerminationDate"
                  @update-date="updateRow($event, item, 'TerminationDate')"
                  :rules="
                    requiredColumns.indexOf('TerminationDate') > -1
                      ? [$rules.required]
                      : []
                  "
                  :class="
                    requiredColumns.indexOf('TerminationDate') > -1
                      ? 'required'
                      : ''
                  "
                  label=" "
                  autofocus
                />
                <span
                  :ref="item.Id + '_15'"
                  class="pbas-table-cell"
                  v-on:dblclick="focusCell(item.Id, 15)"
                  v-else
                >
                  {{ formatDate(item.TerminationDate) }}
                </span>
              </template>
              <template v-if="header.type.key === 'TerminationReason'">
                <no-autocomplete-textfield
                  @keydown.tab.prevent="nextCell(item.Id + '_16')"
                  dense
                  :ref="item.Id + '_16'"
                  v-if="isCellFocused(item.Id, 16)"
                  :disabled="
                    item.IsNew &&
                    item.NewMember !== null &&
                    item.NewMember !== undefined
                  "
                  clearable
                  v-bind:key="header.type.key"
                  style="min-width: 200px; padding: 0"
                  :value="item.TerminationReason"
                  @input="updateRow($event, item, 'TerminationReason')"
                  :rules="
                    hasValue(item.TerminationDate) ? [$rules.required] : []
                  "
                  :class="hasValue(item.TerminationDate) ? 'required' : ''"
                  label=" "
                  autofocus
                />
                <span
                  :ref="item.Id + '_16'"
                  class="pbas-table-cell"
                  v-on:dblclick="focusCell(item.Id, 16)"
                  v-else
                >
                  {{ item.TerminationReason }}
                </span>
              </template>
              <template v-if="header.type.key === 'Amount'">
                <no-autocomplete-textfield
                  @keydown.tab.prevent="nextCell(item.Id + '_17')"
                  dense
                  :ref="item.Id + '_17'"
                  v-if="isCellFocused(item.Id, 17)"
                  clearable
                  :fixedId="'hours-amount-textbox' + item.Id"
                  v-bind:key="header.type.key"
                  style="min-width: 200px; padding: 0"
                  :value="item.Amount"
                  @input="updateRow($event, item, 'Amount')"
                  @keydown="currencyKeydownNegative"
                  @keyup="currencyKeyUpNegative($event, item, 'Amount')"
                  :rules="
                    requiredColumns.indexOf('Amount') > -1
                      ? [$rules.required]
                      : []
                  "
                  :class="
                    requiredColumns.indexOf('Amount') > -1 ? 'required' : ''
                  "
                  label=" "
                  autofocus
                />
                <span
                  :ref="item.Id + '_17'"
                  class="pbas-table-cell"
                  v-on:dblclick="focusCell(item.Id, 17)"
                  v-else
                >
                  {{ formatHours(item.Amount) }}
                </span>
              </template>
              <template v-if="header.type.key === 'ContributionAmount'">
                <no-autocomplete-textfield
                  @keydown.tab.prevent="nextCell(item.Id + '_18')"
                  dense
                  :ref="item.Id + '_18'"
                  v-if="isCellFocused(item.Id, 18)"
                  clearable
                  :fixedId="'hours-contribution-amount-textbox' + item.Id"
                  v-bind:key="header.type.key"
                  style="min-width: 200px; padding: 0"
                  :value="item.ContributionAmount"
                  @input="updateRow($event, item, 'ContributionAmount')"
                  @keydown="currencyKeydown"
                  @keyup="currencyKeyUp($event, item, 'ContributionAmount')"
                  :rules="
                    requiredColumns.indexOf('ContributionAmount') > -1
                      ? [$rules.required]
                      : []
                  "
                  :class="
                    requiredColumns.indexOf('ContributionAmount') > -1
                      ? 'required'
                      : ''
                  "
                  label=" "
                  autofocus
                />
                <span
                  :ref="item.Id + '_18'"
                  class="pbas-table-cell"
                  v-on:dblclick="focusCell(item.Id, 18)"
                  v-else
                >
                  {{ formatCurrency(item.ContributionAmount) }}
                </span>
              </template>
              <template v-if="header.type.key === 'EmployerRate'">
                <no-autocomplete-textfield
                  @keydown.tab.prevent="nextCell(item.Id + '_19')"
                  dense
                  :ref="item.Id + '_19'"
                  v-if="isCellFocused(item.Id, 19)"
                  :disabled="
                    item.IsNew &&
                    item.NewMember !== null &&
                    item.NewMember !== undefined
                  "
                  clearable
                  :fixedId="'employer-rate-textbox' + item.Id"
                  v-bind:key="header.type.key"
                  style="min-width: 200px; padding: 0"
                  :value="item.EmployerRate"
                  @input="updateRow($event, item, 'EmployerRate')"
                  @keydown="currencyKeydown"
                  @keyup="currencyKeyUp($event, item, 'EmployerRate')"
                  :rules="
                    requiredColumns.indexOf('EmployerRate') > -1
                      ? [$rules.required]
                      : []
                  "
                  :class="
                    requiredColumns.indexOf('EmployerRate') > -1
                      ? 'required'
                      : ''
                  "
                  label=" "
                  autofocus
                />
                <span
                  :ref="item.Id + '_19'"
                  class="pbas-table-cell"
                  v-on:dblclick="focusCell(item.Id, 19)"
                  v-else
                >
                  {{ item.EmployerRate }}
                </span>
              </template>
              <template v-if="header.type.key === 'ExpectedContribution'">
                <span>
                  {{ formatCurrency(item.ExpectedContribution) }}
                </span>
              </template>
              <!-- <no-autocomplete-textfield
                :disabled="true"
                :fixedId="'hours-expected-contribution-textbox' + item.Id"
                v-bind:key="header.type.key"
                v-if="header.type.key === 'ExpectedContribution'"
                style="min-width:200px;padding:0"
                :value="item.ExpectedContribution"
                :rules="
                  requiredColumns.indexOf('ExpectedContribution') > -1
                    ? [$rules.required]
                    : []
                "
                :class="
                  requiredColumns.indexOf('ExpectedContribution') > -1
                    ? 'required'
                    : ''
                "
                label=" "
              /> -->
              <template v-if="header.type.key === 'ContributionDiff'">
                <span>
                  {{ formatCurrency(item.ContributionDiff) }}
                </span>
              </template>
              <!-- <no-autocomplete-textfield
                :disabled="true"
                :fixedId="'hours-contribution-diff-textbox' + item.Id"
                v-bind:key="header.type.key"
                v-if="header.type.key === 'ContributionDiff'"
                style="min-width:200px;padding:0"
                :value="item.ContributionAmount"
                :rules="
                  requiredColumns.indexOf('ContributionDiff') > -1
                    ? [$rules.required]
                    : []
                "
                :class="
                  requiredColumns.indexOf('ContributionDiff') > -1
                    ? 'required'
                    : ''
                "
                label=" "
              /> -->
              <!-- <currency-textfield
              prefix=""
              cssstyle="min-width:200px;padding:0;margin-top:-13px"
              :fixedId="'hours-amount-textbox'+item.Id"
              v-if="header.type.key === 'Amount'"
              v-bind:key="header.type.key"
              :value="item.Amount"
              @change="updateRow($event, item, 'Amount')"
              :rules="
                requiredColumns.indexOf('Amount') > -1 ? [$rules.required] : []
              "
              :class="requiredColumns.indexOf('Amount') > -1 ? 'required' : []"
            /> -->
            </div>
          </template>
        </pbas-data-table>
      </v-card-text>
    </template>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn text @click="discard" :disabled="!hasChanges" :loading="loading">
        {{ $t("components.memberimportsalaries.discard_changes") }}
      </v-btn>
      <v-btn
        color="primary"
        @click="savePage"
        :disabled="!hasChanges && !existsUnvalidated"
        :loading="loading"
      >
        {{ $t("components.hoursbulktable.save_page") }}
      </v-btn>
      <!-- <v-btn
      color="primary"
      @click="validatePage(true)"
      :disabled="hasChanges || pageInvalidRecords() === 0"
      :loading="loading"
    >
      {{ $t("components.hoursbulktable.validate_page") }}
    </v-btn> -->
    </v-card-actions>
    <error-handler :error="error"></error-handler>
    <v-dialog scrollable v-model="dialogs.warning" persistent max-width="800">
      <material-card
        :title="$t('components.memberimportsalaries.warning_title')"
        icon="warning"
        :color="$vuetify.theme.themes.light.warning"
      >
        <v-card-text>
          {{ $t("components.memberimportsalaries.warning_text") }}
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="itemsChangeWarningNo">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="primary" @click="itemsChangeWarningYesDiscard">
            {{ $t("components.memberimportsalaries.discard_changes") }}
          </v-btn>
          <v-btn color="primary" @click="itemsChangeWarningYesSave">
            {{ $t("components.memberimportsalaries.save_changes") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" color="success" :timeout="3000">
      {{
        $t("components.hourstable.mass_create_success_message_{0}", [
          numberOfNewMembers,
        ])
      }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
  </v-card>
  <!-- </material-card> -->
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../components/ErrorHandler";
import { ODataProvider } from "pbas-vue-components";
import { translate2 } from "../trans2";
import { translate } from "../trans";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import HoursAddMany from "../components/HoursAddMany";
import SearchMembersFormHours from "./SearchMembersFormHours.vue";
import CreateMemberWizard from "../components/CreateMemberWizard";
import { sortAlphanum } from "../alphanumericSort";
import { ODataHeader, ODataString } from "pbas-vue-components";
import CurrencyTextfield from "../components/CurrencyTextfield";
import TransSelect from "./TransSelect.vue";
import TransSelect2 from "./TransSelect2.vue";
import AutoSelect from "./AutoSelect.vue";

export default {
  components: {
    ErrorHandler,
    NoAutocompleteTextfield,
    HoursAddMany,
    SearchMembersFormHours,
    CreateMemberWizard,
    CurrencyTextfield,
    // HoursValidationErrors
    TransSelect,
    TransSelect2,
    AutoSelect,
  },
  props: ["headers", "pendingImportId", "requiredColumns", "optionalColumns"],
  data() {
    return {
      saving: false,
      recreate: false,
      employers: [],
      addMemberWizardValid: false,
      item: null,
      addMany: false,
      show: true,
      warningOptions: {},
      originalData: [],
      error: null,
      provider: undefined,
      snackbar: false,
      numberOfNewMembers: "",
      floatActions: [
        {
          text: "components.memberselfpaymentstable.add_many",
          color: this.$vuetify.theme.themes.light.success,
          name: "addMany",
          icon: "add",
          handler: () => {
            this.addMany = true;
          },
        },
      ],
      rowActions: [
        {
          name: "merge",
          icon: "merge_type",
          title: "components.hoursbulktable.merge",
          color: this.$vuetify.theme.themes.light.primary,
          handler: (item) => {
            this.item = item;
            this.dialogs.merge = true;
          },
          visible: (item) => item.IsNew,
        },
        {
          name: "create",
          icon: "add",
          title: "components.hoursbulktable.create",
          color: this.$vuetify.theme.themes.light.success,
          handler: (item) => {
            let member = {
              PersonalInfo: {},
              EmploymentInfo: {},
              // ContactInfo: {
              //   Address: {},
              // },
              // BankAccount: {},
              MembershipStatus: {
                MemberGroupIdentity: {},
                EffectiveDate: this.planIdentity.FirstRenewalDate,
              },
            };
            member.Certificate = item.MemberCertificate;
            if (item.SIN !== null && item.SIN !== undefined) {
              member.SIN = item.SIN;
            }
            member.PersonalInfo.FirstName = item.FirstName;
            member.PersonalInfo.LastName = item.LastName;
            if (item.Gender !== null && item.Gender !== undefined) {
              const gender = this.options.Models.Gender.filter(
                (o) =>
                  o.Translations.filter(
                    (t) => t.LanguageCode === this.language.language
                  )[0].DisplayValue === item.Gender
              );
              if (gender.length > 0) {
                member.PersonalInfo.Gender = gender[0];
              }
            }
            member.PersonalInfo.DateOfBirth = item.DateOfBirth;
            if (item.Employer !== null && item.Employer !== undefined) {
              const employer = this.employers.filter(
                (o) =>
                  o.Translations.filter(
                    (t) => t.LanguageCode === this.language.language
                  )[0].Name === item.Employer
              );
              if (employer.length > 0) {
                if (
                  item.Store !== null &&
                  item.Store !== undefined &&
                  employer[0].Stores !== null &&
                  employer[0].Stores !== undefined
                ) {
                  let store = employer[0].Stores.filter(
                    (o) =>
                      o.IsAssignable !== false &&
                      o.Translations.filter(
                        (t) => t.LanguageCode === this.language.language
                      )[0].Name === item.Store
                  );
                  if (store.length === 0) {
                    store = employer[0].Stores.filter(
                      (o) =>
                        o.IsAssignable !== false &&
                        o.Number.toString() === item.Store
                    );
                  }
                  member.EmploymentInfo.Store = store[0];
                }
                member.EmploymentInfo.Employer = employer[0];
              }
            }
            member.EmploymentInfo.EmployeeNumber = item.EmployeeNumber;
            member.EmploymentInfo.Earnings = item.Earnings;
            if (item.Frequency !== null && item.Frequency !== undefined) {
              const frequency = this.options.Models.EmploymentFrequency.filter(
                (o) =>
                  o.Translations.filter(
                    (t) => t.LanguageCode === this.language.language
                  )[0].DisplayValue === item.Frequency
              );
              if (frequency.length > 0) {
                member.EmploymentInfo.EmploymentFrequency = frequency[0];
              }
            }
            if (
              item.EmploymentType !== null &&
              item.EmploymentType !== undefined
            ) {
              const employmentType = this.options.Models.EmploymentType.filter(
                (o) =>
                  o.Translations.filter(
                    (t) => t.LanguageCode === this.language.language
                  )[0].DisplayValue === item.EmploymentType
              );
              if (employmentType.length > 0) {
                member.EmploymentInfo.EmploymentType = employmentType[0];
              }
            }
            member.EmploymentInfo.HireDate = item.HireDate;
            if (
              item.TerminationDate !== null &&
              item.TerminationDate !== undefined
            ) {
              member.CoverageExpiryDate = item.TerminationDate;
            }
            if (
              item.TerminationReason !== null &&
              item.TerminationReason !== undefined
            ) {
              member.CoverageExpiryReason = item.TerminationReason;
            }
            this.item = item;
            this.member = member;
            this.rowId = item.Id;
            this.recreate = false;
            this.dialogs.create = true;
          },
          visible: (item) =>
            item.IsNew &&
            (item.NewMember === null || item.NewMember === undefined),
        },
        {
          name: "recreate",
          icon: "edit",
          title: "components.hoursbulktable.recreate",
          color: this.$vuetify.theme.themes.light.success,
          handler: (item) => {
            this.item = item;
            this.member = item.NewMember;
            this.rowId = item.Id;
            this.recreate = true;
            this.dialogs.create = true;
          },
          visible: (item) =>
            item.IsNew &&
            item.NewMember !== null &&
            item.NewMember !== undefined,
        },
        {
          title: "globals.delete",
          name: "delete",
          icon: "delete",
          handler: (item) => {
            this.item = item;
            this.rowId = item.Id;
            this.dialogs.delete = true;
          },
        },
      ],
      valid: false,
      hasChanges: false,
      disableMode: false,
      loading: false,
      totalInvalidRecords: 1,
      dialogs: {
        merge: false,
        create: false,
        delete: false,
        warning: false,
        massCreate: false,
      },
      member: null,
      rowId: null,
      initialized: false,
      selectActions: [
        {
          name: "massCreate",
          icon: "add",
          title: "components.hoursbulktable.mass_create_members",
          handler: this.loadForMassCreate,
        },
      ],
      allSelected: false,
      existsUnvalidated: false,
      focusDictionary: {},
      itemsNewAndSingleErrorCount: 0,
      someChecked: false,
      validMass: false,
      massMembershipStatus: {},
      memberHeaders: {},
      memberGroups: [],
      classes: [],
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
    ...mapGetters("common", {
      selectedPlan: "plan",
    }),
    ...mapGetters("plansMembers", ["options", "planIdentity", "planOptions"]),
  },
  watch: {
    headers: {
      handler() {
        this.loadData2();
      },
    },
    hasChanges: {
      handler() {
        this.validateFinalize();
      },
    },
  },
  mounted() {
    if (this.headers !== null && this.headers !== undefined) {
      this.loadData2();
      document
        .getElementById("app")
        .addEventListener("click", this.clearEditableCells);
    }
  },
  beforeDestroy() {
    document
      .getElementById("app")
      .removeEventListener("click", this.clearEditableCells, false);
  },
  methods: {
    ...mapActions("plansMembers", [
      "getMembersManagementColumns",
      "bulkUpdatePendingHoursPage",
      "validatePendingHoursPage",
      "deletePendingHourImportItem",
      "getPendingHoursNewMember",
      "getContributionEmployers",
      "massCreateMembersFromHours",
      "getTotalInvalidRecords",
      "getPlanDetailsByDate",
      "getMemberGroupsWithDate",
    ]),
    async loadForMassCreate(items) {
      try {
        console.log(items);
        this.loading = true;
        if (this.planIdentity.HasEligibilityBank) {
          let headers = (
            await this.getMembersManagementColumns(this.selectedPlan.Id)
          ).data.sort((a, b) => {
            return a.order - b.order;
          });

          for (let h of headers) {
            this.memberHeaders[h.text] = h;
          }
          console.log(Object.keys(this.memberHeaders));
          console.log(
            Object.keys(this.memberHeaders).indexOf("Default Coverage Status")
          );
          console.log(Object.keys(this.memberHeaders).indexOf("Class"));
          console.log(Object.keys(this.memberHeaders).indexOf("Member Group"));

          items.sort((a, b) => {
            return new Date(a.StartDate) - new Date(b.StartDate);
          });

          let v = items[0].StartDate;
          let planDetails = (
            await this.getPlanDetailsByDate({
              plan: this.selectedPlan.Id,
              date: v,
            })
          ).data;
          let classes =
            planDetails && planDetails.Classes
              ? JSON.parse(planDetails.Classes)
              : [];
          this.classes = classes;
          this.memberGroups = (
            await this.getMemberGroupsWithDate({
              plan: this.selectedPlan.Id,
              date: v,
              url: "?$expand=Employers,Translations,CoverageIdentities($expand=CurrentCoverageEligibility($expand=CoverageStatuses),Current($expand=Translations,PlanInsuranceCarrier($expand=PolicyIdentity($expand=Current))))",
            })
          ).data.value;
        }
        this.massMembershipStatus = {
          MemberGroupIdentity: {
            Current: null,
          },
        };
        this.dialogs.massCreate = true;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    async setData(items) {
      this.disableMode = true;
      let ids = [];
      for (let item of items) {
        if (
          item.NewMember !== null &&
          item.NewMember !== undefined &&
          Object.keys(item.NewMember).length === 1
        ) {
          ids.push(item.Id);
        }
        const num = parseFloat(item.Amount);
        if (!isNaN(num)) {
          item.Amount = this.formatHours(num);
        } else {
          item.Amount = null;
        }
        item.onlyNewMemberError = this.onlyNewMemberError(item);
      }
      if (ids.length > 0) {
        try {
          let newMembers = (
            await this.getPendingHoursNewMember({
              planIdentityId: this.selectedPlan.Id,
              pendingImportId: this.pendingImportId,
              pendingHourReportIds: ids,
            })
          ).data;
          for (let item of items) {
            if (
              item.NewMember !== null &&
              item.NewMember !== undefined &&
              Object.keys(item.NewMember).length === 1
            ) {
              item.NewMember = newMembers[item.Id];
            }
          }
        } catch (error) {
          this.error = error;
        }
      }
      this.originalData = JSON.parse(JSON.stringify(items));
      this.hasChanges = false;
      this.itemsNewAndSingleErrorCount = items.filter(
        (o) => o.IsNew && o.Errors.length === 1
      ).length;
      this.existsUnvalidated =
        items.filter((o) => !o.IsValid && o.Errors.length === 0).length > 0;
      this.$nextTick(async () => {
        this.disableMode = false;
        for (let item of items) {
          let amountTextbox = document.getElementById(
            "hours-amount-textbox" + item.Id
          );
          if (amountTextbox) {
            amountTextbox.style = "text-align:right";
          }

          let earningsTextBox = document.getElementById(
            "earnings-textbox" + item.Id
          );
          if (earningsTextBox) {
            earningsTextBox.style = "text-align:right";
          }
          // this.amountBlur(item);

          // this.updateRow(item.Amount, item, "Amount")
        }
        this.validateFinalize();
        this.allSelected = false;
      });
    },
    onlyNewMemberError(item) {
      const errors = this.rowErrors(item);
      return (
        errors && errors.length === 1 && errors[0].indexOf("New Member") > -1
      );
    },
    nextCell(currentCell) {
      let splitVals = currentCell.split("_");
      const id = splitVals[0];
      const currentIndex = parseInt(splitVals[1]);
      let found = false;
      let i = currentIndex + 1;
      const maxPossibleFields = 18;
      let nextCell;
      while (!found && i <= maxPossibleFields) {
        nextCell = id + "_" + i.toString();
        if (
          this.$refs[nextCell] === undefined ||
          this.$refs[id + "_" + i.toString()] === null
        ) {
          i++;
        } else {
          found = true;
        }
      }
      if (found) {
        this.focusCell(id, i);
      }
    },
    clearEditableCells(e) {
      if (
        e.target.tagName.toLowerCase() === "input" ||
        e.target.classList.contains("date-picker-clear-btn") ||
        e.target.classList.contains("v-btn__content") ||
        e.target.innerHTML === "calendar_today"
      ) {
        return;
      }
      this.focusDictionary = {};
      this.$forceUpdate();
    },
    formatCurrency(v) {
      let a = parseFloat(v);
      if (isNaN(a)) return "";
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
      });
      return formatter.format(v);
    },
    formatHours(v) {
      let a = parseFloat(v);
      if (isNaN(a)) return "";
      var formatter = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
      });
      return formatter.format(v);
    },
    formatDate(dateString) {
      if (
        dateString === undefined ||
        dateString === null ||
        dateString === ""
      ) {
        return "";
      }
      const [date, time] = dateString.split("T");
      const [year, month, day] = date.split("-");
      return `${year}-${month}-${day}`;
    },
    focusCell(id, index) {
      this.focusDictionary = {};
      this.focusDictionary[id] = index;
      this.$forceUpdate();
    },
    isCellFocused(id, index) {
      return this.focusDictionary[id] === index;
    },
    hasValue(field) {
      return field !== null && field !== undefined && field !== "";
    },
    headerSlotFunc(header) {
      return "header." + header.type.key;
    },
    toggleAll() {
      this.someChecked = false;
      console.log(this.allSelected);
      if (this.allSelected) {
        this.$refs.table.selected = [];
        for (let item of this.$refs.table.fetchResult.items) {
          item.isSelected = false;
        }
        this.allSelected = false;
      } else {
        for (let item of this.$refs.table.fetchResult.items) {
          if (item.Errors.length === 1 && item.IsNew) {
            item.isSelected = true;
          }
        }
        this.$refs.table.selected = this.$refs.table.fetchResult.items.filter(
          (o) => o.isSelected
        );
        this.allSelected = true;
      }
    },
    async massCreate() {
      this.saving = true;
      this.error = null;
      try {
        var payload = this.$refs.table.selected.map((o) => o.Id);

        let membershipStatus = JSON.parse(
          JSON.stringify(this.massMembershipStatus)
        );
        if (
          membershipStatus.MemberGroupIdentity.Current !== null &&
          membershipStatus.MemberGroupIdentity.Current !== undefined
        ) {
          membershipStatus.MemberGroupIdentityId =
            membershipStatus.MemberGroupIdentity.Current.IdentityId;
        }
        delete membershipStatus.MemberGroupIdentity;
        if (
          membershipStatus.DefaultCoverageStatus !== null &&
          membershipStatus.DefaultCoverageStatus !== undefined
        ) {
          membershipStatus.DefaultCoverageStatusId =
            membershipStatus.DefaultCoverageStatus.Id;
          delete membershipStatus.DefaultCoverageStatus;
        }
        payload = {
          Reports: this.$refs.table.selected.map((o) => o.Id),
          MembershipStatus: membershipStatus,
        };

        this.numberOfNewMembers = (
          await this.massCreateMembersFromHours({
            planIdentityId: this.selectedPlan.Id,
            pendingImportId: this.pendingImportId,
            payload: payload,
          })
        ).data;
        this.loadData();
        this.totalInvalidRecords = (
          await this.getTotalInvalidRecords({
            planIdentityId: this.selectedPlan.Id,
            pendingImportId: this.pendingImportId,
          })
        ).data;
        this.snackbar = true;
        this.dialogs.massCreate = false;
      } catch (e) {
        console.error(e);
        this.error = e;
      } finally {
        this.saving = false;
        this.validateFinalize();
      }
    },
    toggle(item) {
      if (item.isSelected) {
        this.$refs.table.selected = this.$refs.table.selected.filter(
          (o) => o.Id !== item.Id
        );
        item.isSelected = false;
      } else {
        this.$refs.table.selected.push(item);
        item.isSelected = true;
      }
      this.allSelected =
        this.$refs.table.selected.length > 0 &&
        this.$refs.table.selected.length ===
          this.$refs.table.fetchResult.items.filter(
            (o) => o.IsNew && o.Errors.length === 1
          ).length;
      this.someChecked =
        this.$refs.table &&
        this.$refs.table.selected.length > 0 &&
        this.$refs.table.selected.length < this.itemsNewAndSingleErrorCount;
    },
    async saveMany() {
      this.addMany = false;
      await this.$refs.table.getDataAsync();
      this.$emit("saved");
      this.validateFinalize();
    },
    totalRows() {
      if (this.$refs.table) {
        return this.$refs.table.fetchResult.items.length;
      }
      return 0;
    },
    pageInvalidRecords() {
      if (this.$refs.table) {
        return this.$refs.table.fetchResult.items.filter((o) => !o.IsValid)
          .length;
      }
      return 0;
    },
    async deleteItem() {
      this.saving = true;
      this.error = null;
      try {
        this.totalInvalidRecords = (
          await this.deletePendingHourImportItem({
            planIdentityId: this.selectedPlan.Id,
            pendingImportId: this.pendingImportId,
            pendingHourReportId: this.rowId,
          })
        ).data.totalInvalidRecords;
        this.loadData();
        this.dialogs.delete = false;
      } catch (e) {
        console.error(e);
        this.error = e;
      } finally {
        this.saving = false;
        this.validateFinalize();
      }
    },
    wizardValid(valid) {
      this.addMemberWizardValid = valid;
    },
    async merge(member) {
      if (
        member.MemberIdentification.Certificate !== null &&
        member.MemberIdentification.Certificate !== undefined
      ) {
        this.updateRow(
          member.MemberIdentification.Certificate,
          this.item,
          "MemberCertificate"
        );
      }
      if (
        member.CurrentMember.FirstName !== null &&
        member.CurrentMember.FirstName !== undefined
      ) {
        this.updateRow(member.CurrentMember.FirstName, this.item, "FirstName");
      }
      if (
        member.CurrentMember.LastName !== null &&
        member.CurrentMember.LastName !== undefined
      ) {
        this.updateRow(member.CurrentMember.LastName, this.item, "LastName");
      }
      if (
        member.CurrentMember.Gender !== null &&
        member.CurrentMember.Gender !== undefined
      ) {
        this.updateRow(
          member.CurrentMember.Gender.Translations.filter(
            (o) => o.LanguageCode === this.language.language
          )[0].DisplayValue,
          this.item,
          "Gender"
        );
        this.updateRow(member.CurrentMember.Gender.Id, this.item, "GenderId");
      }
      if (
        member.CurrentMember.DateOfBirth !== null &&
        member.CurrentMember.DateOfBirth !== undefined
      ) {
        this.updateRow(
          member.CurrentMember.DateOfBirth,
          this.item,
          "DateOfBirth"
        );
      }
      if (
        member.CurrentEmploymentInformation.Employer !== null &&
        member.CurrentEmploymentInformation.Employer !== undefined
      ) {
        this.updateRow(
          member.CurrentEmploymentInformation.Employer.Translations.filter(
            (o) => o.LanguageCode === this.language.language
          )[0].Name,
          this.item,
          "Employer"
        );
        this.updateRow(
          member.CurrentEmploymentInformation.Employer.Id,
          this.item,
          "EmployerId"
        );
      }
      if (
        member.CurrentEmploymentInformation.EmployeeNumber !== null &&
        member.CurrentEmploymentInformation.EmployeeNumber !== undefined
      ) {
        this.updateRow(
          member.CurrentEmploymentInformation.EmployeeNumber,
          this.item,
          "EmployeeNumber"
        );
      }
      if (
        member.CurrentEmploymentInformation.Store !== null &&
        member.CurrentEmploymentInformation.Store !== undefined
      ) {
        this.updateRow(
          member.CurrentEmploymentInformation.Store.Translations.filter(
            (o) => o.LanguageCode === this.language.language
          )[0].Name,
          this.item,
          "Store"
        );
        this.updateRow(
          member.CurrentEmploymentInformation.Store.Id,
          this.item,
          "StoreId"
        );
      }
      if (
        member.CurrentEmploymentInformation.EmploymentFrequency !== null &&
        member.CurrentEmploymentInformation.EmploymentFrequency !== undefined
      ) {
        this.updateRow(
          member.CurrentEmploymentInformation.EmploymentFrequency.Translations.filter(
            (o) => o.LanguageCode === this.language.language
          )[0].DisplayValue,
          this.item,
          "Frequency"
        );
        this.updateRow(
          member.CurrentEmploymentInformation.EmploymentFrequency.Id,
          this.item,
          "FrequencyId"
        );
      }
      if (
        member.CurrentEmploymentInformation.EmploymentType !== null &&
        member.CurrentEmploymentInformation.EmploymentType !== undefined
      ) {
        this.updateRow(
          member.CurrentEmploymentInformation.EmploymentType.Translations.filter(
            (o) => o.LanguageCode === this.language.language
          )[0].DisplayValue,
          this.item,
          "EmploymentType"
        );
        this.updateRow(
          member.CurrentEmploymentInformation.EmploymentType.Id,
          this.item,
          "EmploymentTypeId"
        );
      }
      if (
        member.CurrentEmploymentInformation.HireDate !== null &&
        member.CurrentEmploymentInformation.HireDate !== undefined
      ) {
        this.updateRow(
          member.CurrentEmploymentInformation.HireDate,
          this.item,
          "HireDate"
        );
      }
      await this.savePage();
      this.dialogs.merge = false;
    },
    async saveOne(member) {
      this.updateRow(member.Certificate, this.item, "MemberCertificate");
      this.updateRow(member.SIN, this.item, "SIN");
      if (member.PersonalInfo !== null && member.PersonalInfo !== undefined) {
        this.updateRow(member.PersonalInfo.FirstName, this.item, "FirstName");
        this.updateRow(member.PersonalInfo.LastName, this.item, "LastName");
        if (member.PersonalInfo.Gender) {
          this.updateRow(
            member.PersonalInfo.Gender.Translations.filter(
              (o) => o.LanguageCode === this.language.language
            )[0].DisplayValue,
            this.item,
            "Gender"
          );
        } else {
          this.updateRow(null, this.item, "Gender");
        }
        this.updateRow(
          member.PersonalInfo.DateOfBirth,
          this.item,
          "DateOfBirth"
        );
      }
      if (
        member.EmploymentInfo !== null &&
        member.EmploymentInfo !== undefined
      ) {
        this.updateRow(
          member.EmploymentInfo.Employer.Translations.filter(
            (o) => o.LanguageCode === this.language.language
          )[0].Name,
          this.item,
          "Employer"
        );
        this.updateRow(
          member.EmploymentInfo.Employer.Id,
          this.item,
          "EmployerId"
        );
        this.updateRow(
          member.EmploymentInfo.EmployeeNumber,
          this.item,
          "EmployeeNumber"
        );
        if (member.EmploymentInfo.Store) {
          this.updateRow(
            member.EmploymentInfo.Store.Translations.filter(
              (o) => o.LanguageCode === this.language.language
            )[0].Name,
            this.item,
            "Store"
          );
          this.updateRow(member.EmploymentInfo.Store.Id, this.item, "StoreId");
        } else {
          this.updateRow(null, this.item, "Store");
          this.updateRow(null, this.item, "StoreId");
        }
        if (member.EmploymentInfo.EmploymentFrequency) {
          this.updateRow(
            member.EmploymentInfo.EmploymentFrequency.Translations.filter(
              (o) => o.LanguageCode === this.language.language
            )[0].DisplayValue,
            this.item,
            "Frequency"
          );
          this.updateRow(
            member.EmploymentInfo.EmploymentFrequency.Id,
            this.item,
            "FrequencyId"
          );
        } else {
          this.updateRow(null, this.item, "Frequency");
          this.updateRow(null, this.item, "FrequencyId");
        }
        if (member.EmploymentInfo.EmploymentType) {
          this.updateRow(
            member.EmploymentInfo.EmploymentType.Translations.filter(
              (o) => o.LanguageCode === this.language.language
            )[0].DisplayValue,
            this.item,
            "EmploymentType"
          );
          this.updateRow(
            member.EmploymentInfo.EmploymentType.Id,
            this.item,
            "EmploymentTypeId"
          );
        } else {
          this.updateRow(null, this.item, "EmploymentType");
          this.updateRow(null, this.item, "EmploymentTypeId");
        }
        this.updateRow(member.EmploymentInfo.HireDate, this.item, "HireDate");
      }
      if (member.CoverageExpiryDate) {
        this.updateRow(member.CoverageExpiryDate, this.item, "TerminationDate");
      }
      if (member.CoverageExpiryReason) {
        this.updateRow(
          this.$t("enums." + member.CoverageExpiryReason),
          this.item,
          "TerminationReason"
        );
      }
      this.updateRow(member, this.item, "NewMember");
      await this.savePage();
      this.dialogs.create = false;
    },
    rowErrors(item) {
      let rowErrors = item.Errors;
      if (rowErrors !== null && rowErrors !== undefined) {
        if (rowErrors.length > 0) {
          return rowErrors.map((o) =>
            this.$t("components.hoursbulktable." + o)
          );
          // .join("\n\r");
        } else {
          return [];
        }
      }
      return null;
    },
    clearFilters() {
      delete this.provider.filter;
      this.$refs.table.getDataAsync();
      this.$emit("filter-changed", this.provider.filter);
      this.$forceUpdate();
    },
    filterNewMembers() {
      this.provider.filter = "IsNew eq true";
      this.$refs.table.getDataAsync();
      this.$emit("filter-changed", this.provider.filter);
      this.$forceUpdate();
    },
    filterErrors() {
      this.provider.filter = "IsValid eq false and IsNew eq false";
      this.$refs.table.getDataAsync();
      this.$emit("filter-changed", this.provider.filter);
      this.$forceUpdate();
    },
    filterValid() {
      this.provider.filter = "IsValid eq true or IsNew eq true";
      this.$refs.table.getDataAsync();
      this.$emit("filter-changed", this.provider.filter);
      this.$forceUpdate();
    },
    calculateContribution() {},
    loadData() {
      if (this.provider === null || this.provider === undefined) {
        const url = `/plans/${this.selectedPlan.Id}/pending-imports/${this.pendingImportId}/pending-hour-reports`;
        this.provider = new ODataProvider(
          this.$axiosHttp,
          url,
          this.headers.concat(
            new ODataHeader({
              type: new ODataString("NewMember/Certificate"),
              sortable: false,
              visible: false,
              searchable: false,
              isIdentifier: false,
              allowVisibilityChange: false,
              alwaysInclude: true,
            })
          )
        );
      } else {
        if (this.$refs.table) {
          this.$refs.table.getDataAsync();
        }
      }
    },
    async loadData2() {
      try {
        this.employers = (
          await this.getContributionEmployers({
            planIdentityId: this.selectedPlan.Id,
          })
        ).data.value.sort((a, b) => {
          const translatedA = a.Translations.filter(
            (o) => o.LanguageCode === this.language.language
          )[0].Name;
          const translatedB = b.Translations.filter(
            (o) => o.LanguageCode === this.language.language
          )[0].Name;
          return sortAlphanum(translatedA, translatedB);
        });
        this.loadData();
        this.totalInvalidRecords = (
          await this.getTotalInvalidRecords({
            planIdentityId: this.selectedPlan.Id,
            pendingImportId: this.pendingImportId,
          })
        ).data;
      } catch (error) {
        this.error = error;
      }
    },

    // coverageAllowedDates(val, item) {
    //   const n = Date.parse(val);
    //   const d = new Date(n);
    //   let n2 = Date.parse(item.CoverageEffectiveDate);
    //   const d2 = new Date(n2);
    //   return d >= d2;
    // },

    async itemsChangeWarningNo() {
      this.$refs.table.itemsChangeWarningNo(this.warningOptions);
      this.dialogs.warning = false;
    },
    async itemsChangeWarningYesDiscard() {
      this.$refs.table.itemsChangeWarningYes(this.warningOptions);
      this.dialogs.warning = false;
    },
    async itemsChangeWarningYesSave() {
      await this.savePage();
      this.$refs.table.itemsChangeWarningYes(this.warningOptions);
      this.dialogs.warning = false;
    },
    async itemsChangeWarning(options) {
      const changesExist =
        this.$refs.table.fetchResult.items.filter((o) => o.modified).length > 0;
      if (changesExist) {
        this.warningOptions = options;
        this.dialogs.warning = true;
      } else {
        this.$refs.table.itemsChangeWarningYes(options);
      }
    },
    translate2(item, field) {
      return translate2(item, field);
    },
    translate(item) {
      return translate(item, this.language.language);
    },
    itemSlotFunc(header) {
      return "item." + header.type.key;
    },
    isNumeric(evt) {
      var iKeyCode = evt.which ? evt.which : evt.keyCode;
      if (
        iKeyCode != 46 &&
        iKeyCode > 31 &&
        (iKeyCode < 48 || iKeyCode > 57) &&
        (iKeyCode < 96 || iKeyCode > 105)
      )
        return false;

      return true;
    },
    currencyKeyUp(evt, row, key) {
      var el = evt.srcElement;
      var value = el.value;
      if (!value) return;
      var start = el.selectionStart;
      var end = el.selectionEnd;
      el.value = parseFloat(value).toFixed(2);
      if (start === 0 && end === 0) {
        end = 1;
      }
      el.setSelectionRange(start, end);
      const num = parseFloat(value);
      if (!isNaN(num)) {
        value = num.toFixed(2); //this.formatCurrency(num).substring(1);
      } else {
        value = null;
      }
      this.updateRow(value, row, key);
    },
    currencyKeydown(evt, sender) {
      if (evt.keyCode == 8 || evt.keyCode == 46) {
        return;
      }
      var el = evt.srcElement;
      var value = el.value;
      if (!value) {
        if (evt.keyCode == 190 || evt.keyCode == 110) {
          el.value = value + "0.";
          el.setSelectionRange(2, 2);
        } else if (this.isNumeric(evt)) {
          el.value = value + ".00";
          el.setSelectionRange(0, 0);
        }
      } else if (parseFloat(value) && value.indexOf(".") == -1) {
        var start = el.selectionStart;
        el.value = value + ".00";
        el.setSelectionRange(start, start);
      }
      value = el.value;
      if (
        (evt.keyCode == 190 || evt.keyCode == 110) &&
        value.indexOf(".") >= 0
      ) {
        el.setSelectionRange(value.indexOf(".") + 1, value.indexOf(".") + 1);
        evt.preventDefault();
        return;
      }

      if (!this.isNumeric(evt) && (evt.keyCode < 35 || evt.keyCode > 40)) {
        evt.preventDefault();
      } else if (evt.keyCode === 13) {
        evt.preventDefault();
      }
    },
    currencyKeyUpNegative(evt, row, key) {
      if (evt.keyCode === 189) {
        return;
      }
      var el = evt.srcElement;
      var value = el.value;
      if (!value) return;
      if (
        value === "-0" ||
        value === "-0." ||
        value === "-0.0" ||
        value === "-0.00"
      ) {
        return;
      }
      let decimal = parseFloat(value);
      if (isNaN(decimal)) {
        return;
      }
      var start = el.selectionStart;
      var end = el.selectionEnd;
      el.value = decimal.toFixed(2);
      if (start === 0 && end === 0) {
        end = 1;
      }
      el.setSelectionRange(start, end);
      const num = parseFloat(value);
      if (!isNaN(num)) {
        value = num.toFixed(2); //this.formatCurrency(num).substring(1);
      } else {
        value = null;
      }
      this.updateRow(value, row, key);
    },
    currencyKeydownNegative(evt, sender) {
      console.log(evt);
      if (evt.keyCode == 8 || evt.keyCode == 46) {
        return;
      }
      if (evt.keyCode === 189) {
        return;
      }
      var el = evt.srcElement;
      var value = el.value;

      if (!value) {
        if (evt.keyCode == 190 || evt.keyCode == 110) {
          el.value = value + "0.";
          el.setSelectionRange(2, 2);
        } else if (this.isNumeric(evt)) {
          el.value = value + ".00";
          el.setSelectionRange(0, 0);
        }
      } else if (
        value !== "-" &&
        parseFloat(value) &&
        value.indexOf(".") == -1
      ) {
        console.log(value);
        var start = el.selectionStart;
        el.value = value + ".00";
        el.setSelectionRange(start, start);
      }
      console.log(value, el.value);
      value = el.value;
      console.log(value);
      if (evt.keyCode == 190 || evt.keyCode == 110) {
        if (value.indexOf(".") >= 0) {
          el.setSelectionRange(value.indexOf(".") + 1, value.indexOf(".") + 1);
          evt.preventDefault();
        }
        return;
      }

      if (!this.isNumeric(evt) && (evt.keyCode < 35 || evt.keyCode > 40)) {
        evt.preventDefault();
      } else if (evt.keyCode === 13) {
        evt.preventDefault();
      }
    },
    updateRow(value, row, key) {
      if (this.disableMode) {
        return;
      }
      if (
        (value === null || value === undefined) &&
        (row[key] === null || row[key] === undefined)
      ) {
        return;
      }
      // const index = this.$refs.table.fetchResult.items.indexOf(
      //   this.$refs.table.fetchResult.items.filter(
      //     (o) => o.Identifier === row.Identifier
      //   )[0]
      // );
      // this.$refs.table.fetchResult.items[index][key] = value;
      row[key] = value;
      const original = this.originalData.filter(
        (o) => o.Id == row.Id && o.Identifier == row.Identifier
      )[0];
      row.modified = this.isRowModified(row, original);
      this.setIds(row, key);
      this.hasChanges =
        this.$refs.table.fetchResult.items.filter((o) => o.modified).length > 0;
    },
    setIds(row, key) {
      switch (key) {
        case "MemberCertificate": {
          row.MemberIdentityId = null;
          break;
        }
        case "FirstName": {
          row.MemberIdentityId = null;
          break;
        }
        case "LastName": {
          row.MemberIdentityId = null;
          break;
        }
        case "Gender": {
          row.GenderId = null;
          break;
        }
        case "Employer": {
          row.EmployerId = null;
          break;
        }
        case "Store": {
          row.StoreId = null;
          break;
        }
        case "Frequency": {
          row.FrequencyId = null;
          break;
        }
        case "EmploymentType": {
          row.EmploymentTypeId = null;
          break;
        }
        case "TermName": {
          row.TermId = null;
          break;
        }
        case "TermYear": {
          row.TermId = null;
          break;
        }
      }
    },
    isRowModified(row, original) {
      let modified = false;
      for (let col of this.requiredColumns) {
        modified = row[col] !== original[col];
        if (modified) {
          return true;
        }
      }
      for (let col of this.optionalColumns) {
        modified = row[col] !== original[col];
        if (modified) {
          return true;
        }
      }
      return modified;
    },
    isRowValid(item) {
      let valid = true;
      for (let col of this.requiredColumns) {
        valid =
          item[col] !== null && item[col] !== undefined && item[col] !== "";
        if (!valid) {
          return false;
        }
      }
      return valid;
    },
    async savePage() {
      this.loading = true;
      try {
        let items = JSON.parse(
          JSON.stringify(
            this.$refs.table.fetchResult.items.filter(
              (o) => o.modified || (!o.IsValid && o.Errors.length === 0)
            )
          )
        );
        for (const item of items) {
          if (item.NewMember !== null && item.NewMember !== undefined) {
            item.NewMember = this.fixForSave(item.NewMember);
          }
        }
        this.totalInvalidRecords = (
          await this.bulkUpdatePendingHoursPage({
            planIdentityId: this.selectedPlan.Id,
            pendingImportId: this.pendingImportId,
            payload: items,
          })
        ).data.totalInvalidRecords;
        await this.$refs.table.getDataAsync();
        this.$emit("saved");
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
        this.validateFinalize();
      }
    },
    fixForSave(item) {
      let member = JSON.parse(JSON.stringify(item));

      if (member.BankAccount) {
        if (Object.keys(member.BankAccount).length === 0) {
          delete member.BankAccount;
        } else {
          member.BankAccount.EffectiveDate = member.MembershipStatus.EffectiveDate;
        }
      } else {
        delete member.BankAccount;
      }

      member.PlanIdentityId = this.selectedPlan.Id;

      member.PersonalInfo.EffectiveDate = member.MembershipStatus.EffectiveDate;
      member.ContactInfo.EffectiveDate = member.MembershipStatus.EffectiveDate;
      member.EmploymentInfo.EffectiveDate = member.MembershipStatus.EffectiveDate;

      if (member.PersonalInfo.Title) {
        member.PersonalInfo.TitleId = member.PersonalInfo.Title.Id;
        delete member.PersonalInfo.Title;
      }
      if (member.PersonalInfo.Pronoun) {
        member.PersonalInfo.PronounId = member.PersonalInfo.Pronoun.Id;
        delete member.PersonalInfo.Pronoun;
      }
      if (member.PersonalInfo.Gender) {
        member.PersonalInfo.GenderId = member.PersonalInfo.Gender.Id;
        delete member.PersonalInfo.Gender;
      }
      if (member.PersonalInfo.MaritalStatus) {
        member.PersonalInfo.MaritalStatusId =
          member.PersonalInfo.MaritalStatus.Id;
        delete member.PersonalInfo.MaritalStatus;
      }
      if (member.PersonalInfo.ProvinceOfResidence) {
        member.PersonalInfo.ProvinceOfResidenceId =
          member.PersonalInfo.ProvinceOfResidence.Id;
        delete member.PersonalInfo.ProvinceOfResidence;
      }
      if (member.PersonalInfo.Suffix) {
        member.PersonalInfo.SuffixId = member.PersonalInfo.Suffix.Id;
        delete member.PersonalInfo.Suffix;
      }
      if (member.PersonalInfo.ProvinceOfEmployment) {
        member.PersonalInfo.ProvinceOfEmploymentId =
          member.PersonalInfo.ProvinceOfEmployment.Id;
        delete member.PersonalInfo.ProvinceOfEmployment;
      }
      
      if (member.EmploymentInfo.Employer) {
        member.EmploymentInfo.EmployerId = member.EmploymentInfo.Employer.Id;
        delete member.EmploymentInfo.Employer;
      }
      if (member.EmploymentInfo.Store) {
        member.EmploymentInfo.StoreId = member.EmploymentInfo.Store.Id;
        delete member.EmploymentInfo.Store;
      }
      if (member.EmploymentInfo.EmploymentType) {
        member.EmploymentInfo.EmploymentTypeId =
          member.EmploymentInfo.EmploymentType.Id;
        delete member.EmploymentInfo.EmploymentType;
      }
      if (member.EmploymentInfo.EmploymentFrequency) {
        member.EmploymentInfo.EmploymentFrequencyId =
          member.EmploymentInfo.EmploymentFrequency.Id;
        delete member.EmploymentInfo.EmploymentFrequency;
      }
      if (member.EmploymentInfo.EarningsFrequency) {
        member.EmploymentInfo.EarningsFrequencyId =
          member.EmploymentInfo.EarningsFrequency.Id;
        delete member.EmploymentInfo.EarningsFrequency;
      }
      if (member.EmploymentInfo.IncomeType) {
        member.EmploymentInfo.IncomeTypeId =
          member.EmploymentInfo.IncomeType.Id;
        delete member.EmploymentInfo.IncomeType;
      }
      if (member.EmploymentInfo.SecondIncomeEarningsFrequency) {
        member.EmploymentInfo.SecondIncomeEarningsFrequencyId =
          member.EmploymentInfo.SecondIncomeEarningsFrequency.Id;
        delete member.EmploymentInfo.SecondIncomeEarningsFrequency;
      }
      if (member.EmploymentInfo.SecondIncomeType) {
        member.EmploymentInfo.SecondIncomeTypeId =
          member.EmploymentInfo.SecondIncomeType.Id;
        delete member.EmploymentInfo.SecondIncomeType;
      }
      if (
        member.EmploymentInfo.WeeklyHours !== null &&
        member.EmploymentInfo.WeeklyHours !== undefined
      ) {
        const decimalValue = parseFloat(member.EmploymentInfo.WeeklyHours);
        if (!isNaN(decimalValue)) {
          member.EmploymentInfo.WeeklyHours = decimalValue;
        } else {
          delete member.EmploymentInfo.WeeklyHours;
        }
      }
      
      // if (member.ContactInfo.LanguageChoice) {
      //   member.ContactInfo.LanguageChoiceId =
      //     member.ContactInfo.LanguageChoice.Id;
      //   delete member.ContactInfo.LanguageChoice;
      // }
      // if (member.ContactInfo.CommunicationPreference) {
      //   member.ContactInfo.CommunicationPreferenceId =
      //     member.ContactInfo.CommunicationPreference.Id;
      //   delete member.ContactInfo.CommunicationPreference;
      // }
      // if (member.ContactInfo.Address) {
      //   if (Object.keys(member.ContactInfo.Address).length > 0) {
      //     if (member.ContactInfo.Address.Country) {
      //       member.ContactInfo.Address.CountryId =
      //         member.ContactInfo.Address.Country.Id;
      //       delete member.ContactInfo.Address.Country;
      //     }
      //     if (member.ContactInfo.Address.Province) {
      //       member.ContactInfo.Address.ProvinceId =
      //         member.ContactInfo.Address.Province.Id;
      //       delete member.ContactInfo.Address.Province;
      //     }
      //     // member.ContactInfo.Address.PostalCode = this.unmask(
      //     //   member.ContactInfo.Address.PostalCode,
      //     //   this.postalCodeMask
      //     // );
      //   } else {
      //     delete member.ContactInfo.Address;
      //   }
      // } else {
      //   delete member.ContactInfo.Address;
      // }
      // if (
      //   member.ContactInfo.PhoneNumber !== null &&
      //   member.ContactInfo.PhoneNumber !== undefined
      // ) {
      //   // member.ContactInfo.PhoneNumber = this.unmask(
      //   //   member.ContactInfo.PhoneNumber,
      //   //   this.telephoneMask
      //   // );
      // }
      // if (Object.keys(member.ContactInfo).length === 0) {
      //   delete member.ContactInfo;
      // }

      for (let dependant of member.Dependants) {
        dependant.EffectiveDate = member.MembershipStatus.EffectiveDate;
        if (dependant.Relationship) {
          dependant.RelationshipId = dependant.Relationship.Id;
          delete dependant.Relationship;
        }
        if (dependant.Gender) {
          dependant.GenderId = dependant.Gender.Id;
          delete dependant.Gender;
        }
        if (dependant.Title) {
          dependant.TitleId = dependant.Title.Id;
          delete dependant.Title;
        }
        if (dependant.Suffix) {
          dependant.SuffixId = dependant.Suffix.Id;
          delete dependant.Suffix;
        }
        if (dependant.Student === null) {
          dependant.Student = false;
        }
        // dependant.Identity.Identifier = dependant.Identifier.toString();
        // delete dependant.Identifier;
      }
      // if (member.MembershipStatus.DefaultCoverageStatus) {
      //   member.MembershipStatus.DefaultCoverageStatusId =
      //     member.MembershipStatus.DefaultCoverageStatus.Id;
      //   delete member.MembershipStatus.DefaultCoverageStatus;
      // }
      // for (let i = 0; i < member.MemberBenefits.length; i++) {
      //   delete member.MemberBenefits[i].CoverageIdentity;
      //   if (
      //     member.MemberBenefits[i].CoverageStatus !== null &&
      //     member.MemberBenefits[i].CoverageStatus !== undefined
      //   ) {
      //     member.MemberBenefits[i].CoverageStatusId =
      //       member.MemberBenefits[i].CoverageStatus.Id;
      //     delete member.MemberBenefits[i].CoverageStatus;
      //   }
      //   member.MemberBenefits[i].EffectiveDate =
      //     member.MembershipStatus.EffectiveDate;
      //   if (Object.keys(member.MemberBenefits[i].COB).length === 0) {
      //     delete member.MemberBenefits[i].COB;
      //   } else {
      //     delete member.MemberBenefits[i].COB.cobBool;
      //   }
      //   if (
      //     member.MemberBenefits[i].Dependants !== null &&
      //     member.MemberBenefits[i].Dependants !== undefined
      //   ) {
      //     const depIds = JSON.parse(
      //       JSON.stringify(member.MemberBenefits[i].Dependants)
      //     );
      //     delete member.MemberBenefits[i].Dependants;
      //     member.MemberBenefits[i].DependantIdentities = [];
      //     for (let depId of depIds) {
      //       const d = member.Dependants.filter(
      //         (o) => o.Identity.Identifier === depId.toString()
      //       )[0];
      //       member.MemberBenefits[i].DependantIdentities.push(d.Identity);
      //     }
      //   }
      // }

      if (member.EmploymentInfo.WeeklyHours) {
        member.EmploymentInfo.WeeklyHours = parseInt(
          member.EmploymentInfo.WeeklyHours
        );
      }
      if (member.EmploymentInfo.Earnings) {
        member.EmploymentInfo.Earnings = parseFloat(
          member.EmploymentInfo.Earnings
        );
      }
      if (member.EmploymentInfo.SecondIncomeEarnings) {
        member.EmploymentInfo.SecondIncomeEarnings = parseFloat(
          member.EmploymentInfo.SecondIncomeEarnings
        );
      }
      if (
        member.MembershipStatus.MemberGroupIdentity &&
        member.MembershipStatus.MemberGroupIdentity.Current &&
        member.MembershipStatus.MemberGroupIdentity.Current.IdentityId
      ) {
        member.MembershipStatus.MemberGroupIdentityId =
          member.MembershipStatus.MemberGroupIdentity.Current.IdentityId;
        delete member.MembershipStatus.MemberGroupIdentity;
      }
      if (member.MembershipStatus.DefaultCoverageStatus) {
        member.MembershipStatus.DefaultCoverageStatusId =
          member.MembershipStatus.DefaultCoverageStatus.Id;
        delete member.MembershipStatus.DefaultCoverageStatus;
      }

      for (let benefit of member.CustomizedMemberBenefits) {
        if (
          benefit.COB !== null &&
          benefit.COB !== undefined &&
          Object.keys(benefit.COB).length === 0
        ) {
          delete benefit.COB;
        }
        if (benefit.CoverageIdentity) {
          if (benefit.CoverageIdentity.CurrentCoverageEligibility) {
            benefit.CoverageIdentity.CurrentCoverageEligibility.EffectiveDate = member.MembershipStatus.EffectiveDate;
          }
          if (benefit.CoverageIdentity.Current) {
            benefit.CoverageIdentity.Current.EffectiveDate = member.MembershipStatus.EffectiveDate;
          }
        }
      }

      for (let benefit of member.NonCustomizedMemberBenefits) {
        if (
          benefit.COB !== null &&
          benefit.COB !== undefined &&
          Object.keys(benefit.COB).length === 0
        ) {
          delete benefit.COB;
        }
      }

      return member;
    },
    async discard() {
      await this.$refs.table.getDataAsync();
    },
    // async validatePage(ids) {
    //   this.loading = true;
    //   try {
    //     this.totalInvalidRecords = (await this.validatePendingHoursPage({
    //       planIdentityId: this.selectedPlan.Id,
    //       pendingImportId: this.pendingImportId,
    //       payload: ids,
    //     })).data.totalInvalidRecords;
    //   } catch (error) {
    //     this.error = error;
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    validateFinalize() {
      console.log(
        this.hasChanges,
        this.totalInvalidRecords,
        this.totalRows(),
        this.pageInvalidRecords()
      );
      const valid =
        !this.hasChanges &&
        this.totalInvalidRecords === 0 &&
        this.totalRows() > 0 &&
        this.pageInvalidRecords() === 0;
      this.$emit("valid", valid);
      return valid;
    },
    getActionsFor(item) {
      if (!item) {
        return [];
      }
      return this.visibleRowActionsFunc(item);
    },
    visibleRowActionsFunc(item) {
      if (this.rowActions == null) {
        return [];
      }
      return this.rowActions.filter((a) => {
        if (a.visible === undefined) {
          return true;
        }
        return a.visible(item) !== false;
      });
    },
  },
};
</script>
<style scoped>
.previous-value-tooltip {
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  margin-bottom: 10px;
}
.v-tooltip__content {
  background-color: orange;
  max-width: fit-content !important;
  width: fit-content !important;
}
#hours-amount-textbox {
  text-align: right;
}
input {
  text-align: right;
}
.v-application .white {
  background-color: rgba(0, 0, 0, 0.87) !important;
}
.v-input__slot {
  background-color: rgba(0, 0, 0, 0.87) !important;
}
.btns-container > .v-btn--disabled {
  color: #008080 !important;
}
.selected-row {
  background-color: #d6eaf8;
}
.pbas-table-cell {
  height: -webkit-fill-available;
  width: -webkit-fill-available;
}
</style>
